module.exports = __webpack_public_path__ + "media/images/lp_chintai/sp_main-5811a7240a14c0086838c4b56c478016.png";